import { Box } from '@mui/material';
import SpreedlyCheckoutSdkIframeField from '../../fields/spreedly-checkout-sdk-iframe-field.component';
import {
  spreedlyCheckoutSdkCvvName,
  spreedlyCheckoutSdkNumberName,
} from '../../spreedly-checkout-sdk-form.component';
import { useTranslation } from 'react-i18next';

const SpreedlyCheckoutSdkCvvForm = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="grid"
      gridTemplateColumns="2fr 1fr"
      gap={theme => theme.spacing(1)}
      data-testid="SpreedlyCard.Container"
    >
      <SpreedlyCheckoutSdkIframeField
        name={spreedlyCheckoutSdkNumberName}
        label={t('checkout.payment.spreedly.fields.cardNumber.label')}
        id="spreedly-number-test"
      />
      <SpreedlyCheckoutSdkIframeField
        name={spreedlyCheckoutSdkCvvName}
        label={t('checkout.payment.spreedly.fields.cvv.label')}
        id="spreedly-cvv-test"
      />
    </Box>
  );
};

export default SpreedlyCheckoutSdkCvvForm;
